<template>
<div>
  <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
  <div v-if="fetch">
   
<!-- <section class="">
	<div class="container  col-lg-6 mt-3" style=" "  >
		
			<div  > 
<div id="carouselExampleControls" class="carousel slide " data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="d-block w-100" src="../assets/main/images/b2.png" alt="First slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="../assets/main/images/b3.png" alt="Second slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="../assets/main/images/b1.png" alt="Third slide">
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
</div>
		
	</div>
</section> -->

<!-- <section class="">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				
				<div class="advance-search">
					<form>
						
					</form>
				</div>
			</div>
		</div>
	</div>
</section>
<ul>
  <li ></li>
</ul> -->
<section class="section-sm" style="padding-top:15px;">
	<div class="container">
    <div class="row mb-4">
			<div class="col-md-12">
				<div class="search-result bg-gray text-center">
					<h2 style="letter-spacing: -2px;"> 
                        <span class="text-secondary">My</span>
                        <span style="color: orange; letter-spacing: -5px;">S</span> 
                        <span style="color: red; letter-spacing: -5px;">H</span>
                        <span style="color: blue; letter-spacing: -5px;">O</span>
                        <span style="color: green; letter-spacing: -5px;">P</span>
                        <span style="color: purple; letter-spacing: -5px;">i</span>
                        <span style="color: purple; letter-spacing: -5px;">N</span>
                    </h2>
				
				</div>
			</div>
		</div>

		<div class="row">
	
			<div class="col-sm-12">
				<div class="product-grid-list">
					<div class="row mt-30 justify-content-around" >
            <div v-if="noresults" class="mt-3 mb-2 text-center text-danger h4">You Haven't Added Any Favourite Shops Yet  </div>
            <div v-if="nofavshops" class="mt-3 mb-2 text-center text-danger h4">You Haven't Any Favourite Shops</div>
              <template v-for=" (shop, i) in shops" >
						<div class=" col-12 col-sm-6 col-md-6 col-lg-4 " v-bind:key="shop.id">
							<!-- product card -->
<div class="product-item bg-light">
	<div class="card">
<!--      
		<div class="thumb-content" style="-webkit-clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%);
clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%); height:250px;">
		
			<a href="">
				<img class="card-img-top img-fluid" src="../../static/images/product-detail-01.jpg" alt="Shop image cap">
			</a>
		</div> -->
    <div class="block2-pic hov-img0">
            		<router-link v-if="shop.isHosted != true && shop.isCloned != true"  :to="{name: 'storehome', params: {storename: shop.owner}}"><img  :src="shop.homeimg" alt="IMG-SHOP" ></router-link>
            	<router-link v-if="shop.isCloned == true"  :to="{name: 'storehome', params: {storename: shop.realOwner}}"><img :src="shop.homeimg" alt="IMG-SHOP" ></router-link>		
            	<a v-if="shop.isHosted == true" target="blank" :href="shop.domain"><img  :src="shop.homeimg" alt="IMG-SHOP" ></a>
							
								<!-- <el-checkbox v-model="checked"  style="visibility: hidden;" 	@change="submit(checked)"> 
										<i class="fa fa-heart" style="visibility: visible;"></i>
									</el-checkbox> -->
								<!-- <i class="fa fa-heart fa-lg text-info" v-b-tooltip.hover title="Add to Wishlist"></i> -->
							
							<!-- <a href="#" class="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</a> -->
						</div>
		<div class="card-body">
   
		    <span class="float-right"><i class="fa fa-trash fa-lg text-danger" style="cursor: pointer; font-size: 20px;" @click="delFavShop(shop)" ></i></span>
             <span class="float-right mr-3"><i class="fa fa-heart-o text-danger" style="font-size: 18px;"></i></span>

		   <span class="card-title" v-if="shop.isHosted != true && shop.isCloned != true" ><router-link  :to="{name: 'storehome', params: {storename: shop.owner}}" class="text-primary">{{shop.name}}</router-link></span>
          <span class="card-title" v-if="shop.isCloned == true"><router-link  :to="{name: 'storehome', params: {storename: shop.realOwner}}" class="text-primary">{{shop.name}}</router-link></span>
          <span class="card-title" v-if="shop.isHosted == true"><a :href="shop.domain" target="blank" class="text-primary">{{shop.name}}</a></span>

		     <ul class="list-inline product-meta mb-1 mt-2" v-if="shop.plan == 'Premium' || shop.plan == 'Enterprise'">
            <li class="list-inline-item mr-2">
		    		<a class="" style="color:red;"><i class="fa fa-home" aria-hidden="true"></i>Home Deliver</a>
		    	</li>
		    </ul>
        <ul class="list-inline product-meta mb-1">
		    	<li class="list-inline-item mr-2">
		    		<a class=""><i class="fa fa-map-marker" aria-hidden="true"></i>{{shop.location}}</a>
		    	</li>
              
		    </ul>
		    <ul class="list-inline product-meta mb-1">
		    	<li class="list-inline-item ">
		    		<a class=""><i  class="fa fa-tag" aria-hidden="true"></i>{{shop.category}}</a>
		    	</li>
		    </ul>
         <ul class="list-inline product-meta mb-1" v-if="shop.shoptype != ''">
		    	<li class="list-inline-item ">
		    		<a class=""><i  class="fa fa-tag" aria-hidden="true"></i>{{shop.shoptype}}</a>
		    	</li>
		    </ul>
         <!-- <ul class="list-inline product-meta mb-1">
		    	<li class="list-inline-item">
		    		<a><i  class="fa fa-eye  " aria-hidden="true"></i>Views {{shop.visits}}</a>
		    	</li>
		    </ul> -->
		    <ul class="list-inline product-meta mb-1" v-if="shop.details.etime && shop.details.stime">
		    	<li class="list-inline-item mr-2">
		    		<a class=""><i class="fa fa-clock-o" aria-hidden="true"></i>Open - Close  {{shop.details.stime}} AM  - {{shop.details.etime}} PM </a>
		    	</li>
              
		    </ul>
		    <ul class="list-inline product-meta mb-1" v-if="shop.details.tel1">
		    	<li class="list-inline-item">
		    		<a><i class="fa fa-phone-square" aria-hidden="true"></i>+94 {{shop.details.tel1}}</a>
		    	</li>
		    	
		    </ul>
		    <ul class="list-inline product-meta mb-2" v-if="shop.details.address">
		    	<li class="list-inline-item">
		    		<a><i class="fa fa-address-card " aria-hidden="true"></i>{{shop.details.address}}</a>
		    	</li>
		    	
		    </ul>
        
		</div>
	</div>
</div>



						</div>
            </template>
						<!-- <div class="col-sm-12 col-lg-3 col-md-3">
						
<div class="product-item bg-light">
	<div class="card">
		<div class="thumb-content" style="-webkit-clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%);
clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%); background-color: #fff; height: 200px;">
		
			<a href="">
				<img class="card-img-top img-fluid" src="images/products/sunset3.jpg" alt="">
			</a>
		</div>
		<div class="card-body">
		    <h4 class="card-title "><a href="" class="text-dark">Study Table Combo</a></h4>
		    <ul class="list-inline product-meta">
		    	<li class="list-inline-item">
		    		<a ><i class="fa fa-folder-open-o"></i>Furnitures</a>
		    	</li>
		    	<li class="list-inline-item">
		    		<a ><i class="fa fa-calendar"></i>26th December</a>
		    	</li>
		    </ul>
		    
		    <div class="product-ratings">
		    	<ul class="list-inline">
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item "><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item ml-1"><span>Delete from favourite</span><i class="fa fa-trash ml-2 text-danger"></i></li>
		    	</ul>
		    </div>
		</div>
	</div>
</div>
		</div> -->
			
					
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- <div class="flex-c-m flex-w w-full pb-5">
			
				<button @click="moreItems()" v-if="lastVisible !== undefined && this.$route.query.cat != '' && this.$route.query.loc != '' && this.$route.fullPath != '/search'" class="flex-c-m stext-101 cl5 size-103 bg2 bor1">
					More Shops
				</button>
			
			</div> -->
<!--============================
=            Footer            =
=============================-->

 
  </div>
  </div>
</template>
<script>
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
import towns from '../../data/towns'
export default {
  name: 'myshopin',
   data() {
      return {
          loading: false,
          loading1: false,
          fetch: false,
          noresults: false,
          nofavshops:false,
          shops:[],
          category:'',
          location:'',
          sortby:'',
        labelPosition: "left",
        links: [],
        isVisible: false,
        lastVisible:'',
        favshops: [],
      };
    },
    
    methods: {
     
       delFavShop(shop){
            var index = this.favshops[0].favshops.indexOf(shop.id)
            //console.log(index)
            //console.log(shop.id)
            if(index > -1){    
                this.favshops[0].favshops.splice(index, 1)
                //console.log(this.favshops[0].favshops)
                db.collection('users').doc(this.favshops[0].docid)
					.update({
					favshops: this.favshops[0].favshops
					})
					.then(() => {
            //console.log('removed fav shop')
            })
          .catch(error => {
            //console.log('error',error)
          })
              this.backToTop()
              this.shops = this.shops.filter((s) => {
                return s.id !== shop.id;
              })
              if(this.shops.length == 0){
                this.nofavshops = true
              }
            }
            //console.log('shops', this.shops)
        },
      
      // userVisits(n){
      //   if(firebase.auth().currentUser){
      //     if(firebase.auth().currentUser.displayName == 'shop owner'){
      //       var newVisits = this.shops[n].visits
      //     }
      //     if(firebase.auth().currentUser.displayName != 'shop owner'){
      //        var newVisits = this.shops[n].visits + 1
      //   //console.log('newvists', newVisits)
      //    db.collection('shops').doc(this.shops[n].id)
      //   .update({
      //     visits: newVisits
      //   })
      //   .then(() => //console.log('newvists', newVisits))
      //   .catch(error => //console.log('error',error))
      //     }
      //   }else{
      //   var newVisits = this.shops[n].visits + 1
      //   //console.log('newvists', newVisits)
      //    db.collection('shops').doc(this.shops[n].id)
      //   .update({
      //     visits: newVisits
      //   })
      //   .then(() => //console.log('newvists', newVisits))
      //   .catch(error => //console.log('error',error))
      //   }
      // },
     
     initToTopButton: function() {
      $(document).bind('scroll', function() {
        var backToTopButton = $('.goTop');
        if ($(document).scrollTop() > 250) {
          backToTopButton.addClass('isVisible');
          this.isVisible = true;
        } else {
          backToTopButton.removeClass('isVisible');
          this.isVisible = false;
        }
      }.bind(this));
    },
    backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    },

    // moreItems(){
		//   if(this.lastVisible != undefined){
		//    db.collection('shops').where("shoptype", "==", this.$route.query.cat)
    //   .where("location", "==", this.$route.query.loc)
    //   .orderBy('rank')
    //   .orderBy('visits', 'desc')
    //   .startAfter(this.lastVisible)
    //   .limit(20).get()
    // .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id' : doc.id,
    //       'name': doc.data().name,
    //       'category': doc.data().shoptype,
    //       'location': doc.data().location,
    //       'owner' : doc.data().owner,
    //       'visits': doc.data().visits
    //     }
    //     this.shops.push(data)
    //     //console.log(this.shops)
    //   })
    //   	this.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
		// 	  //console.log(" moreitems last", this.lastVisible);
		// 	  //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
		// 	  if(querySnapshot.docs.length < 20){
		// 		  this.lastVisible = undefined
  	// 				//console.log("last", this.lastVisible);
		// 	  }
    //   })
		//   }
	  // },
    },
    created(){
       this.$nextTick(function() { 
         this.initToTopButton();
    })
    this.backToTop()
    this.loading1 = true
      this.fetch = false
     db.collection('users').where('uid', '==', firebase.auth().currentUser.uid).get()
      .then(Snapshot => {
      Snapshot.forEach(doc => {
        const data = {
          'favshops' : doc.data().favshops,
          'docid' : doc.id
          
        }
        this.favshops.push(data)
          //console.log(this.favshops)
      })
      }).catch(error => alert(error))
     .then( () => {
       if(this.favshops[0].favshops.length != 0){
      this.favshops[0].favshops.forEach( shopId => {
          db.collection('shops').doc(shopId).get()    
          .then(doc => {
                    const data = {
                            'id' : doc.id,
                            'name': doc.data().name,
                            'category': doc.data().cat,
                            'shoptype': doc.data().shoptype,
                            'location': doc.data().location,
                            'owner' : doc.data().owner,
                            'visits': doc.data().visits,
                            'homeimg':doc.data().homeimg,
                            'plan':doc.data().plan,
                            'details':doc.data().details,
                             'isHosted' : doc.data().isHosted,
                            'domain' : doc.data().domain,
                            'isCloned' : doc.data().isCloned,
                            'realOwner' : doc.data().realOwner
                            }
                    this.shops.push(data)
                    //console.log('shops',this.shops)
                    this.loading1 = false
                this.fetch = true
                 if(this.shops.length == 0){
                  this.noresults = true
                    //console.log("noresults", this.noresults);
                }
                // this.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
                // //console.log(" moreitems last", this.lastVisible);
                // //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
                // if(querySnapshot.docs.length < 1){
                //   this.lastVisible = undefined
                //     //console.log("last", this.lastVisible);
                // } 
                
           }).catch(error => alert(error))
           
         })
       }else{
          this.loading1 = false
          this.fetch = true
          this.noresults = true
       }
    }).catch(error => alert(error))
    },
    mounted() {   
    this.links = towns;  
  },
   

}
</script>
<style scoped>
   @import url('~@/assets/main/css/styles.css');
   @import url('~@/assets/admin/css/admin-loader.css');
   /* @import url('~@/assets/main/css/nav.css');
    @import url('~@/assets/main/css/button.css');
    @import url('~@/assets/main/css/loading.css'); */

.block2-pic{
  position: relative;
}
  .hov-img0 {
  display: block;
  overflow: hidden;
}

.hov-img0 img{
  width: 100%;
  -webkit-transition: transform 0.9s ease;
  -o-transition: transform 0.9s ease;
  -moz-transition: transform 0.9s ease;
  transition: transform 0.9s ease;
}

.hov-img0:hover img {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}

  .goTop {
    cursor: pointer;
  border-radius: 5px;
  background-color: rgb(1,14,27);
  background-color: rgba(1, 14, 27, .7);
  position: fixed;
  width: 45px;
  height: 45px;
  display: block;
  right: 15px;
  bottom: 15px;
  border: none;
  opacity: 0;
  z-index: -1;
  }
 
  .product-meta li a i {
    color: #7C7ADA;
    font-size: 14px;
  }
  .product-meta li a {
    color:  #4A4AEC;
  }
  .product-meta li a :hover {
    color: #7C7ADA;
  }
  .fa {
    color: #7C7ADA;
    font-size: 15px;
}

.isVisible {
  opacity: .8;
  z-index: 4;
  transition: all .4s ease-in;
}

.flex-c-m {
	justify-content: center;
	-ms-align-items: center;
	align-items: center;
}
.flex-w {
	-webkit-flex-wrap: wrap;
	-moz-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	-o-flex-wrap: wrap;
	flex-wrap: wrap;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
}
.w-full {width: 100%;}
.bg2 {background-color: #717fe0;}

.size-103 {
  min-width: 129px;
  height: 46px;
  cursor: pointer;
}	
.cl5 {color: #fff;}
.stext-101 {
  font-size: 15px;
  line-height: 1.466667;
  text-transform: uppercase;
}

.m-nav{
  display: none;
}
.bg-dark{
    color: #180000 !important;
    background-color: #180000 !important;
  }
  .f-sm-link{
    text-decoration: none;
  }
@media (max-width: 767px){
	.m-size {
		font-size: 16px;
  }
  .form-item {
  width: 150px;
  }
  .d-nav{
    display: none;
  }
  .m-nav{
    display: block;
  }
  .bg-dark{
    color: #180000 !important;
    background-color: #180000 !important;
  }
  .navbar-brand {
    display: inline-block;
    padding-top: 0rem; 
    padding-bottom: 0rem;
    margin-right: 1rem;
    line-height: inherit;
    white-space: nowrap;
}
  .navbar-toggler {
    padding: 0rem;
    
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0rem; 
}
  .m-link{
    font-size: 15px;
  }
}
@media (max-width: 575px){
  .el-form{
   width: 150px;
  }
  .m-size {
		font-size: 14px;
  }
  .category-search-filter {
    padding-bottom: 8px;
    margin-bottom: 25px;
  }
  .search-result{
    margin-top: 12px;
  }
  .m-link{
    font-size: 14px;
  }
  .m-f-text{
    font-size: 12px;
  }
  .footer .block ul li a{
    font-size: 12px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/admin/MyShopin.vue